<template>
  <div class="exam-page">
    <div class="exam-container">
      <div v-if="loginPage" style="text-align: left; width: 350px;">
        <b-form-group
          id="input-group-1"
          label="Email"
          label-for="input-1" 
          class="color-white"
        >
          <b-form-input
            id="input-1"
            v-model="email"
            type="email"
            placeholder="Enter email"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-2"
          label="Password"
          label-for="input-2" 
          class="color-white"
        >
          <b-form-input
            id="input-2"
            v-model="password"
            type="password"
            placeholder="Enter password"
            required
          ></b-form-input>
        </b-form-group>
        <my-button type="teal" @click="loginNow" class="mt-3" block>
          <fa-icon icon="sign-in-alt" class="mr-1"></fa-icon>
          Login
        </my-button>
      </div>
      <div v-else>
        <img src="/img/icons/post-exam.svg" width="65" />
        <h3 class="color-white mt-3 text-center">Sesi anda telah berakhir</h3>
        <p class="color-white">
          Silahkan login untuk mengakses konten
        </p>

        <my-button type="teal" @click="handleYaClick" class="mt-3">
          <fa-icon icon="play" class="mr-1"></fa-icon>
          Login
        </my-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as types from "../store/types";

export default {
  data() {
    return {
      email: "", 
      password: "",
      loginPage: false,
      pagination: []
    };
  },
  mounted() {
    if(this.isLoggedIn && this.$route.params.section > 0) {
      this.$router.push("/class/"+this.$route.params.section);
    } 
    if(this.isLoggedIn && this.$route.params.tryout > 0) {
      this.$router.push("/tryout/"+this.$route.params.tryout);
    }
  },
  methods: {
    ...mapActions({
      login: types.LOGIN,
      logout: types.LOGOUT
    }),
    loginNow() {
      if(this.email && this.password) {
        this.login({email: this.email, password: this.password})
        .then(response => {
          if(this.$route.query.section > 0) {
            this.$router.push("/class/"+this.$route.query.section);
          } else if(this.$route.query.tryout > 0) {
            this.$router.push("/tryout/"+this.$route.query.tryout);
          } else if(this.$route.query.redirect) {
            this.$router.push(this.$route.query.redirect);
          } else {
            this.$router.push("/no-subject");
          }
        }).catch(error => {
          this.$bvToast.toast('Email atau password salah', {
            title: 'Failed',
            autoHideDelay: 3000, 
            toaster: 'b-toaster-top-center',
            variant: 'danger'
          })
        })
      } else {
        this.$bvToast.toast('Silahkan isi email & password', {
          title: 'Empty Data',
          autoHideDelay: 3000, 
          toaster: 'b-toaster-top-center',
          variant: 'danger'
        })
      }
    },
    handleYaClick() {
      this.loginPage = true
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: types.IS_LOGGED_IN
    })
  }
};
</script>

<style>
.exam-container {
  height: calc(100vh - 140px);
  background-image: linear-gradient(
    59deg,
    #56c8ff 1%,
    #2190e9 53%,
    #00cbae 114%
  );

  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.passing-grade {
  font-size: 12px;
  color: #009feb;
}
</style>
